import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {FreeDataLevel} from './FreeDataLevel';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class FreeDataValue extends BasicEntity {
children: FreeDataValue[];
chronoCode: string;
code: string;
dataType: string;
defaultTrigger: string;
defaultValue: string;
deletable: boolean | null;
description: TranslatedEmb;
enabled: boolean | null;
endDate: number | null;
externalCode: string;
externalFreedataCode: string;
externalParentCode: string;
fdid: number | null;
freeDataCode: string;
freedataLevel: FreeDataLevel;
icon: string;
label: TranslatedEmb;
level: number | null;
moreArgsJson: Object;
order: number | null;
parentCode: string;
restrict: string;
startDate: number | null;
valor: string;
}

